export const FETCH_MEDICINES_REQUEST = "FETCH_MEDICINES_REQUEST";
export const FETCH_MEDICINES_SUCCESS = "FETCH_MEDICINES_SUCCESS";
export const FETCH_MEDICINES_FAILURE = "FETCH_MEDICINES_FAILURE";

export const ADD_MEDICINE_REQUEST = "ADD_MEDICINE_REQUEST";
export const ADD_MEDICINE_SUCCESS = "ADD_MEDICINE_SUCCESS";
export const ADD_MEDICINE_FAILURE = "ADD_MEDICINE_FAILURE";

export const UPDATE_MEDICINE_REQUEST = "UPDATE_MEDICINE_REQUEST";
export const UPDATE_MEDICINE_SUCCESS = "UPDATE_MEDICINE_SUCCESS";
export const UPDATE_MEDICINE_FAILURE = "UPDATE_MEDICINE_FAILURE";

export const DELETE_MEDICINE_REQUEST = "DELETE_MEDICINE_REQUEST";
export const DELETE_MEDICINE_SUCCESS = "DELETE_MEDICINE_SUCCESS";
export const DELETE_MEDICINE_FAILURE = "DELETE_MEDICINE_FAILURE";

export const TOGGLE_MEDICINE_STATUS_REQUEST = "TOGGLE_MEDICINE_STATUS_REQUEST";
export const TOGGLE_MEDICINE_STATUS_SUCCESS = "TOGGLE_MEDICINE_STATUS_SUCCESS";
export const TOGGLE_MEDICINE_STATUS_FAILURE = "TOGGLE_MEDICINE_STATUS_FAILURE";

export const SEARCH_MEDICINES_REQUEST = "SEARCH_MEDICINES_REQUEST";
export const SEARCH_MEDICINES_SUCCESS = "SEARCH_MEDICINES_SUCCESS";
export const SEARCH_MEDICINES_FAILURE = "SEARCH_MEDICINES_FAILURE";

export const FILTER_MEDICINES_LOCAL = "FILTER_MEDICINES_LOCAL";
